import {Dispatch, SetStateAction, useState} from 'react'
import {useAuth} from '../modules/auth'
import {getShareholder, getShareholders} from '../modules/captable-management/core/_requests'

export const useFetchShareholders = (
  setShareholderDetail: Dispatch<SetStateAction<any>>,
  setImgName: Dispatch<SetStateAction<any>>
) => {
  const [stakeHoldersDataLoading, setStakeHoldersDataLoading] = useState(false)
  const [openShareholderDropdown, setOpenShareholderDropdown] = useState(false)
  const [newEntryButtonClicked, setNewEntryButtonClicked] = useState(false)
  const [dropDownData, setDropDownData] = useState<any[]>([])
  const [dropdownDataLoading, setDropDownDataLoading] = useState<boolean>(false)
  const {companyId} = useAuth()
  const [fieldClicked, setFieldClicked] = useState<string>('')

  const fetchStakeholder = async (id: string) => {
    if (!companyId) return
    setStakeHoldersDataLoading(true)
    try {
      const {
        data: {data, success},
      } = await getShareholder(companyId, id)
      if (success) {
        setShareholderDetail(data)
        setImgName(data?.profileImage?.name)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setStakeHoldersDataLoading(false)
    }
  }

  const onClickFocusText = (e: any) => {
    setFieldClicked(e.target.ariaLabel)
    if (e.target.ariaLabel === 'shareholderName' && !newEntryButtonClicked) {
      setOpenShareholderDropdown(true)
      if (dropDownData.length === 0) {
        fetchShareholderDropDownData()
      }
    }
  }

  const onClickBlurText = (e: any) => {
    setFieldClicked(e.target.ariaLabel)
  }

  const fetchShareholderDropDownData = async () => {
    if (!companyId) return
    try {
      setDropDownDataLoading(true)
      const {
        data: {data, success},
      } = await getShareholders(companyId!, true)
      if (success) {
        setDropDownDataLoading(false)
        setDropDownData(data.shareholders)
      }
    } catch (error) {
      setDropDownDataLoading(false)
      console.error('Error fetching dropdown data:', error)
    } finally {
      setDropDownDataLoading(false)
    }
  }

  return {
    fetchStakeholder,
    stakeHoldersDataLoading,
    onClickFocusText,
    fieldClicked,
    onClickBlurText,
    openShareholderDropdown,
    setOpenShareholderDropdown,
    dropdownDataLoading,
    dropDownData,
    setDropDownData,
    setNewEntryButtonClicked,
  }
}
